export enum DAY_COUNT_KEYS {
  ONE_ONE = 'ONE_ONE',
  ACT_ACT_ISDA = 'ACT_ACT_ISDA',
  ACT_360 = 'ACT_360',
  BOND_BASIS_30_360 = 'BOND_BASIS_30_360',
  EUROBOND_30E_360 = 'EUROBOND_30E_360',
  ACT_365_FIXED = 'ACT_365_FIXED',
  ISDA_30E_360 = 'ISDA_30E_360',
  ACT_ACT_ICMA = 'ACT_ACT_ICMA',
  US_30_360 = 'US_30_360',
  ACT_360_ICMA = 'ACT_360_ICMA',
  ACT_365L = 'ACT_365L',
  ICMA_30_360 = 'ICMA_30_360',
}

export const DAY_COUNT = [
  { id: DAY_COUNT_KEYS.ONE_ONE, displayValue: '1/1' },
  { id: DAY_COUNT_KEYS.ACT_ACT_ISDA, displayValue: 'Actual/Actual' },
  { id: DAY_COUNT_KEYS.ACT_360, displayValue: 'Actual/360' },
  { id: DAY_COUNT_KEYS.BOND_BASIS_30_360, displayValue: '30/360' },
  { id: DAY_COUNT_KEYS.EUROBOND_30E_360, displayValue: '30E/360' },
  { id: DAY_COUNT_KEYS.ACT_365_FIXED, displayValue: 'Actual/365 (Fixed)' },
  { id: DAY_COUNT_KEYS.ISDA_30E_360, displayValue: '30E/360 (ISDA)' },
  { id: DAY_COUNT_KEYS.ACT_ACT_ICMA, displayValue: 'Actual/Actual (ICMA)' },
  { id: DAY_COUNT_KEYS.US_30_360, displayValue: '30/360 (US)' },
  { id: DAY_COUNT_KEYS.ACT_360_ICMA, displayValue: 'Actual/360 (ICMA)' },
  { id: DAY_COUNT_KEYS.ACT_365L, displayValue: 'Actual/365L' },
  { id: DAY_COUNT_KEYS.ICMA_30_360, displayValue: '30/360 (ICMA)' },
];
